import { useCallback, useEffect, useState } from 'react';
import { useApi } from '../../../../hooks';
import { downloadBlobFileOnClick } from '../../../../helpers';
import { useAreDatesValid } from './useAreDatesValid';
import { usePeriodTooLong } from './usePeriodTooLong';

export const useGetReport = ({
  initialForm, onChangeCallback, getReports, withDownload, changeForm, withMinDate = false,
}) => {
  const [form, setForm] = useState({ ...initialForm });
  const [dateError, setDateError] = useState(null);
  const [isCleared, setIsCleared] = useState(false);
  const REPORT_FILES_BASE_URL = process.env.REACT_APP_REPORT_FILES_BASE_URL;
  // const REPORT_FILES_BASE_URL = 'https://api-waste.lenobl.ru';
  // const downloadFile = useCallback((response) => downloadBlobFileOnClick(REPORT_FILES_BASE_URL + response?.file_url, 'Аналитический отчет'), []);
  const downloadFile = useCallback((response) => downloadBlobFileOnClick(response?.file_url, 'Аналитический отчет'), []);

  const clear = useCallback(() => {
    setForm({ ...initialForm });
    setIsCleared(true);
  }, [initialForm]);

  const { makeRequest, isLoading: loadingCountReports } = useApi({
    request: async () => {
      if (dateError) return;
      const response = await getReports?.({ form });
      if (withDownload) downloadFile(response);
      return response;
    },
  });

  const onChange = useCallback(({ target: { name } }, value) => {
    if (changeForm) { 
      changeForm(setForm, { name, value, form });
      if ( name === 'year') setIsCleared(true);
    } else { 
      setForm({ ...form, [name]: value });
    }

    onChangeCallback?.({
      name, value, makeRequest, form,
    });
  }, [changeForm, form, makeRequest, onChangeCallback]);

  const areDatesValid = useAreDatesValid(form.date_from, form.date_to);
  const {
    date_to, date_from, last_day, year, consolidatedYear,
  } = form ?? {};

  const isPeriodTooLong = usePeriodTooLong({
    date_from, date_to, last_day, year,
  });

  useEffect(() => {
    if (withMinDate && date_from && (new Date(date_from) < new Date('2025-12-31'))) {
      setDateError('Дата начала не может быть раньше 01.01.2026');
    } else if (date_from && date_to && !areDatesValid) {
      setDateError('Дата начала не может быть позже даты окончания');
    } else if ((date_from && date_to && isPeriodTooLong) || (year && last_day && isPeriodTooLong)) {
      setDateError('Период превышает 1 календарный год');
    } else if (consolidatedYear && consolidatedYear < 2026) {
      setDateError('Год должен быть не ранее 2026');
    } else {
      setDateError(null);
    }
  }, [date_from, date_to, areDatesValid, isPeriodTooLong, consolidatedYear]);

  return {
    form, onChange, makeRequest, loadingCountReports, clear, dateError, isCleared, setIsCleared,
  };
};
